import React, { useState } from "react";
import { IDispositionForm } from "../../types/campaignTypes";
import Select from "react-select";
import * as Yup from "yup";

import { useAppSelector } from "../../store/hooks";
import { ErrorMessage, Field, Formik, Form } from "formik";
import { SubDisposition } from "../../types/tempTypes";
import { store } from "../../store/store";
import { addCampaignLeadDisposition } from "../../store/actions/campaignActions";
import { setLoader } from "../../store/slices/feature/loader/loaderSlice";
export default function CampaignLeadAddDisposition() {
  const dispositionList = useAppSelector(
    (state) => state?.temp.dispositionList
  );
  const leadData = useAppSelector((state) => state?.campaign.lead);
  const currentUser = useAppSelector((state) => state.user?.userProfile);
  const initialValues: IDispositionForm = {
    leadId: leadData.leadId,
    agentId: currentUser.userId,
    dispositionId: null,
    subDispositionId: null,
    subDispositionChildId: null,
    nextStepDispositionId: null,
    notes: "",
  };
  const validationSchema = Yup.object().shape({
    dispositionId: Yup.number()
      .strict(true)
      .required("Please select Disposition"),
    subDispositionId: Yup.number()
      .strict(true)
      .required("Please enter Sub Disposition"),
    notes: Yup.string().strict(true).required("Please enter remarks"),
  });
  const [subDispositionList, setSubDispositionList] =
    useState<SubDisposition[]>();
  return (
    <div>
      <div className="font-semibold	text-2xl my-2">Submit Disposition</div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          console.log(values);
          store.dispatch(addCampaignLeadDisposition(values));
        }}
      >
        {(formikProps) => (
          <>
            {/* {console.log(formikProps)}{" "} */}
            <Form className="flex gap-8   items-center  w-[100%]  flex-wrap justify-center">
              <div className="">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Disposition
                    </label>
                    <Select
                      isSearchable
                      id="dispositionId"
                      name="dispositionId"
                      options={dispositionList.map((item) => ({
                        value: item.dispositionId,
                        label: item.name,
                        ...item,
                      }))}
                      placeholder="Select disposition"
                      noOptionsMessage={() => "No matching record found"}
                      onChange={(option: any) => {
                        console.log(option);
                        setSubDispositionList(option.subDisposition);

                        formikProps.setFieldValue(
                          "dispositionId",
                          option.value
                        );
                        formikProps.setFieldValue("subDispositionId", 0);
                      }}
                    />
                    <ErrorMessage
                      component="div"
                      name="dispositionId"
                      className="text-red-500 text-xs "
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Sub Disposition
                    </label>
                    <Select
                      isSearchable
                      id="subDispositionId"
                      name="subDispositionId"
                      options={
                        subDispositionList &&
                        subDispositionList.map((item) => ({
                          value: item.subDispositionId,
                          label: item.name,
                          ...item,
                        }))
                      }
                      placeholder="Select Sub Disposition"
                      noOptionsMessage={() => "No matching record found"}
                      onChange={(option: any) => {
                        console.log(option);
                        // setSubDispositionList(option.subDisposition);

                        formikProps.setFieldValue(
                          "subDispositionId",
                          option.value
                        );
                      }}
                    />
                    <ErrorMessage
                      component="div"
                      name="subDispositionId"
                      className="text-red-500 text-xs "
                    />
                  </div>
                </div>

                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Notes
                    </label>
                    <Field
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="notes"
                      name="notes"
                      type="text"
                      as="textarea"
                    />{" "}
                    <ErrorMessage
                      component="div"
                      name="notes"
                      className="text-red-500 text-xs "
                    />
                  </div>
                </div>
              </div>
              <button
                // onClick={() => {}}
                className={`bg-primary-dark px-4 py-2 rounded-md text-white text-[1.1rem] font-[500] ml-5 w-[150px]`}
                type="submit"
              >
                {"Submit"}
              </button>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
